export default [
  {
    "machine_name (Elasticsearch)": "relay_mosfet_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_2",
    "JA label": "パッケージ",
    "EN label": "Package",
    "CN label": "包裹",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_3",
    "JA label": "端子数",
    "EN label": "Number of terminals",
    "CN label": "端子数",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_4",
    "JA label": "接点構成",
    "EN label": "Contact Form",
    "CN label": "接点构成",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_5",
    "JA label": "負荷電圧(V)",
    "EN label": "Load Voltage (AC Peak/DC)(V)",
    "CN label": "负载电压(V)",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_6",
    "JA label": "連続負荷電流(mA)",
    "EN label": "Continuous Load Current (AC Peak /DC)(mA)",
    "CN label": "连续负载电流 (mA)",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_7",
    "JA label": "オン抵抗標準 (Ω)",
    "EN label": "Typical Resistance with Output ON (Ω)",
    "CN label": "导通电阻标准 (Ω)",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_8",
    "JA label": "入出力間耐電圧 (V)",
    "EN label": "Dielectric Strength between Input and Output(V)",
    "CN label": "输入输出间耐压(V)",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_9",
    "JA label": "端子構造",
    "EN label": "Terminal",
    "CN label": "端子构造",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_10",
    "JA label": "梱包形態",
    "EN label": "Packing",
    "CN label": "包装",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_11",
    "JA label": "サイズ幅 (mm)",
    "EN label": "Width size (mm)",
    "CN label": "宽度尺寸 (mm)",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_12",
    "JA label": "サイズ（奥行）",
    "EN label": "Size (length)",
    "CN label": "尺寸（长度）",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_13",
    "JA label": "サイズ高さ (mm)",
    "EN label": "Height size (mm)",
    "CN label": "高度尺寸 (mm)",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_14",
    "JA label": "製品カテゴリ2",
    "EN label": "Category 2",
    "CN label": "类别 2",
    "補足事項 / コメント": "MOS FETリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_15",
    "JA label": "端子間容量　標準 (pF)",
    "EN label": "Capacitance Typ (pF)",
    "CN label": "端子间电容　标准 (pF)",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_16",
    "JA label": "動作時間　最大 (ms)",
    "EN label": "Turn-ON time Max (ms)",
    "CN label": "动作时间　最大 (ms)",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_17",
    "JA label": "復帰時間　最大 (ms)",
    "EN label": "Turn-OFF time Max (ms)",
    "CN label": "复位时间　最大 (ms)",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_18",
    "JA label": "漏れ電流　最大 (nA)",
    "EN label": "Current leakage Max (nA)",
    "CN label": "漏电流　最大 (nA)",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_19",
    "JA label": "トリガLED順電流　最大 (mA)",
    "EN label": "Trigger LED current Max (mA)",
    "CN label": "触发LED正向电流　最大 (mA)",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mosfet_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_2",
    "JA label": "コイル定格電圧(V)",
    "EN label": "Coil Rated voltage",
    "CN label": "线圈 定电压",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_3",
    "JA label": "接点構成",
    "EN label": "Contact Form",
    "CN label": "接点构成",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_4",
    "JA label": "接点機構",
    "EN label": "Contact Type",
    "CN label": "接触机构",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_5",
    "JA label": "接点電流(最大値)(A) （汎用/DC）",
    "EN label": "Max. Switching Current(A)",
    "CN label": "接点电流(最大值)(A)",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_6",
    "JA label": "端子形状/接点端子 （汎用/DC）",
    "EN label": "Terminal Shape/Contact terminals",
    "CN label": "端子形状/线圈端子",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_7",
    "JA label": "端子形状/コイル端子 （DC）",
    "EN label": "Terminal Shape/Coil terminals",
    "CN label": "端子形状/线圈端子",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_8",
    "JA label": "コイル種類",
    "EN label": "Coil Type",
    "CN label": "线圈种类",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_9",
    "JA label": "最大開閉電流(A) （DCのみ)",
    "EN label": "Max. Switching Current(A)",
    "CN label": "最大开关电流(A)",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_10",
    "JA label": "定格通電電流(A) （DCのみ)",
    "EN label": "Rated Carry Current(A)",
    "CN label": "额定通电电流(A)",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_11",
    "JA label": "保護構造",
    "EN label": "Enclosure",
    "CN label": "保护构造",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_12",
    "JA label": "サイズ幅 (mm)",
    "EN label": "Width size (mm)",
    "CN label": "宽度尺寸 (mm)",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_13",
    "JA label": "サイズ奥行 (mm)",
    "EN label": "Length size (mm)",
    "CN label": "长度尺寸 (mm)",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_14",
    "JA label": "サイズ高さ (mm)",
    "EN label": "Height size (mm)",
    "CN label": "高度尺寸 (mm)",
    "補足事項 / コメント": "信号用リレー / パワーリレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_mechanical_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_2",
    "JA label": "分類",
    "EN label": "Classification",
    "CN label": "分类",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_3",
    "JA label": "接点構成",
    "EN label": "Contact Form",
    "CN label": "接点构成",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_4",
    "JA label": "最大開閉電圧(V)",
    "EN label": "Max. Switching Voltage(V)",
    "CN label": "成 最大开关电压(V)",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_5",
    "JA label": "最大開閉電流N.O.(A)",
    "EN label": "Max. Switching Current(A)",
    "CN label": "最大开关电流(A)",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_6",
    "JA label": "定格通電電流N.O.(A)",
    "EN label": "Rated Carry Current(A)",
    "CN label": "额定通电电流(A)",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_7",
    "JA label": "端子形状/コイル端子",
    "EN label": "Terminal Shape/Coil terminals",
    "CN label": "端子形状/线圈端子",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_8",
    "JA label": "端子形状/接点端子",
    "EN label": "Terminal Shape/Contact terminals",
    "CN label": "端子形状/线圈端子",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_9",
    "JA label": "保護構造",
    "EN label": "Enclosure",
    "CN label": "保护构造",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_10",
    "JA label": "サイズ幅 (mm)",
    "EN label": "Width size (mm)",
    "CN label": "宽度尺寸 (mm)",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_11",
    "JA label": "サイズ奥行 (mm)",
    "EN label": "Length size (mm)",
    "CN label": "长度尺寸 (mm)",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_12",
    "JA label": "サイズ高さ (mm)",
    "EN label": "Height size (mm)",
    "CN label": "高度尺寸 (mm)",
    "補足事項 / コメント": "車載用リレー"
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "relay_automotive_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_2",
    "JA label": "サイズ幅 (mm)",
    "EN label": "Width size (mm)",
    "CN label": "宽度尺寸 (mm)",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_3",
    "JA label": "サイズ奥行 (mm)",
    "EN label": "Length size (mm)",
    "CN label": "长度尺寸 (mm)",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_4",
    "JA label": "サイズ高さ (mm)",
    "EN label": "Height size (mm)",
    "CN label": "高度尺寸 (mm)",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_5",
    "JA label": "定格(抵抗負荷)",
    "EN label": "Ratings",
    "CN label": "额定(电阻负载)",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_6",
    "JA label": "接触仕様",
    "EN label": "Contact Form",
    "CN label": "接触规格",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {

    "machine_name (Elasticsearch)": "switch_basic_7",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": "これは削除されたフィールドです。再利用しないでください。 https://dd-is.atlassian.net/browse/OMEMCDEV-2359"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_8",
    "JA label": "電気的耐久性 (Min.)",
    "EN label": "Electrical Durability (Min.)",
    "CN label": "电气耐久性 (Min.)",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_9",
    "JA label": "アクチュエータ",
    "EN label": "Actuator",
    "CN label": "驱动器",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_10",
    "JA label": "端子形状",
    "EN label": "Terminal",
    "CN label": "端子形状",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_11",
    "JA label": "定格電力",
    "EN label": "Resistor power ratings",
    "CN label": "额定功率",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_12",
    "JA label": "保護構造",
    "EN label": "Protection",
    "CN label": "保护构造",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_13",
    "JA label": "安全規格",
    "EN label": "Safety Standard",
    "CN label": "安全认证",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": "これは削除されたフィールドです。再利用しないでください。 https://dd-is.atlassian.net/browse/OMEMCDEV-2359"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_15",
    "JA label": "カバー種類",
    "EN label": "Cover Type",
    "CN label": "安装构造",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_16",
    "JA label": "接点材質",
    "EN label": "Contact Material",
    "CN label": "接点材质",
    "補足事項 / コメント": "マイクロスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_basic_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_2",
    "JA label": "サイズ幅 (mm)",
    "EN label": "Width size (mm)",
    "CN label": "宽度尺寸 (mm)",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_3",
    "JA label": "サイズ奥行 (mm)",
    "EN label": "Length size (mm)",
    "CN label": "长度尺寸 (mm)",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_4",
    "JA label": "サイズ高さ (mm)",
    "EN label": "Height size (mm)",
    "CN label": "高度尺寸 (mm)",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_5",
    "JA label": "定格(抵抗負荷)",
    "EN label": "Ratings",
    "CN label": "额定(电阻负载)",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_6",
    "JA label": "接触仕様",
    "EN label": "Contact Form",
    "CN label": "接触规格",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_7",
    "JA label": "動作に必要な力(最大)(N)",
    "EN label": "Operating Force(N)",
    "CN label": "动作力(最大)(N)",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_8",
    "JA label": "電気的耐久性 (Min.)",
    "EN label": "Electrical Durability (Min.)",
    "CN label": "电气耐久性 (Min.)",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_9",
    "JA label": "アクチュエータ",
    "EN label": "Actuator",
    "CN label": "驱动器",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_10",
    "JA label": "端子形状",
    "EN label": "Terminal",
    "CN label": "端子形状",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_11",
    "JA label": "保護構造",
    "EN label": "Protection",
    "CN label": "保护构造",
    "補足事項 / コメント": "検出スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_12",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_detection_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_2",
    "JA label": "サイズ幅 (mm)",
    "EN label": "Width size (mm)",
    "CN label": "宽度尺寸 (mm)",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_3",
    "JA label": "サイズ奥行 (mm)",
    "EN label": "Length size (mm)",
    "CN label": "长度尺寸 (mm)",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_4",
    "JA label": "サイズ高さ (mm)",
    "EN label": "Height size (mm)",
    "CN label": "高度尺寸 (mm)",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_5",
    "JA label": "定格(抵抗負荷)",
    "EN label": "Ratings",
    "CN label": "额定(电阻负载)",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_6",
    "JA label": "接触仕様",
    "EN label": "Contact Form",
    "CN label": "接触规格",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_7",
    "JA label": "動作に必要な力(最大)(N)",
    "EN label": "Operating Force(N)",
    "CN label": "动作力(最大)(N)",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_8",
    "JA label": "電気的耐久性 (Min.)",
    "EN label": "Electrical Durability (Min.)",
    "CN label": "电气耐久性 (Min.)",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_9",
    "JA label": "アクチュエータ",
    "EN label": "Actuator",
    "CN label": "驱动器",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_10",
    "JA label": "端子形状",
    "EN label": "Terminal",
    "CN label": "端子形状",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_11",
    "JA label": "マウント",
    "EN label": "Mounting",
    "CN label": "安装形式",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_12",
    "JA label": "本体色",
    "EN label": "Color",
    "CN label": "本体颜色",
    "補足事項 / コメント": "ドア/電源スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_door_power_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_2",
    "JA label": "端子形状",
    "EN label": "Terminal",
    "CN label": "端子形状",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_3",
    "JA label": "サイズ幅 (mm)",
    "EN label": "Width size (mm)",
    "CN label": "宽度尺寸 (mm)",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_4",
    "JA label": "サイズ奥行 (mm)",
    "EN label": "Length size (mm)",
    "CN label": "长度尺寸 (mm)",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_5",
    "JA label": "サイズ高さ (mm)",
    "EN label": "Height size (mm)",
    "CN label": "高度尺寸 (mm)",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_6",
    "JA label": "動作に必要な力(最大)(N)",
    "EN label": "Operating Force(N)",
    "CN label": "动作力(最大)(N)",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_7",
    "JA label": "種類",
    "EN label": "Type",
    "CN label": "种类",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_8",
    "JA label": "耐久性(最大OF時)(Min.)",
    "EN label": "Durability (Min.)",
    "CN label": "耐久性 (Min.)",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_9",
    "JA label": "接点(めっき)",
    "EN label": "Contact plating",
    "CN label": "接点(电镀)",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_10",
    "JA label": "プランジャ",
    "EN label": "Plunger",
    "CN label": "柱塞",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_11",
    "JA label": "アース",
    "EN label": "Ground Terminal",
    "CN label": "地线",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_12",
    "JA label": "保護構造",
    "EN label": "Protection",
    "CN label": "保护构造",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_13",
    "JA label": "プランジャ色",
    "EN label": "Plunger color",
    "CN label": "柱塞颜色",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_14",
    "JA label": "LED",
    "EN label": "LED",
    "CN label": "LED",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_15",
    "JA label": "動作までの動き",
    "EN label": "Pretravel(PT)",
    "CN label": "预行程(PT)",
    "補足事項 / コメント": "タクタイルスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_tactile_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "rocker_1",
    "JA label": "サイズ幅 (mm)",
    "EN label": "Width size (mm)",
    "CN label": "宽度尺寸 (mm)",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_2",
    "JA label": "サイズ奥行 (mm)",
    "EN label": "Length size (mm)",
    "CN label": "长度尺寸 (mm)",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_3",
    "JA label": "サイズ高さ (mm)",
    "EN label": "Height size (mm)",
    "CN label": "高度尺寸 (mm)",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_4",
    "JA label": "端子構造 (接触形式)",
    "EN label": "Contact form",
    "CN label": "端子构造",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_5",
    "JA label": "定格",
    "EN label": "Ratings",
    "CN label": "额定值",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_6",
    "JA label": "端子形状",
    "EN label": "Terminal",
    "CN label": "端子形状",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_7",
    "JA label": "マーキング",
    "EN label": "Markings",
    "CN label": "罩盖标记",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_8",
    "JA label": "照光",
    "EN label": "Illumination",
    "CN label": "发光",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_9",
    "JA label": "リセット機能",
    "EN label": "Reset Function",
    "CN label": "复位功能",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_10",
    "JA label": "安全規格認証",
    "EN label": "Safety Standards",
    "CN label": "安全标准认证",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_11",
    "JA label": "特殊機能",
    "EN label": "Special Function",
    "CN label": "特殊功能",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_12",
    "JA label": "保護構造",
    "EN label": "Protection",
    "CN label": "保护构造",
    "補足事項 / コメント": "ロッカースイッチ"
  },
  {
    "machine_name (Elasticsearch)": "rocker_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "rocker_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "rocker_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "rocker_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "rocker_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "rocker_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "rocker_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "rocker_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "押しボタンスイッチ/表示灯"
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_2",
    "JA label": "取付穴サイズ",
    "EN label": "Mounting Holes",
    "CN label": "安装孔尺寸",
    "補足事項 / コメント": "押しボタンスイッチ/表示灯"
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_3",
    "JA label": "照光",
    "EN label": "Illumination",
    "CN label": "照光",
    "補足事項 / コメント": "押しボタンスイッチ/表示灯"
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_4",
    "JA label": "操作部形状/ボタン",
    "EN label": "Pushbutton",
    "CN label": "操作部形状",
    "補足事項 / コメント": "押しボタンスイッチ/表示灯"
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_5",
    "JA label": "動作機能",
    "EN label": "Operating",
    "CN label": "动作功能",
    "補足事項 / コメント": "押しボタンスイッチ/表示灯"
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_6",
    "JA label": "接点構成",
    "EN label": "Contact Form",
    "CN label": "接点构成",
    "補足事項 / コメント": "押しボタンスイッチ/表示灯"
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_7",
    "JA label": "端子形状",
    "EN label": "Terminal",
    "CN label": "端子形状",
    "補足事項 / コメント": "押しボタンスイッチ/表示灯"
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_8",
    "JA label": "保護構造",
    "EN label": "Protection",
    "CN label": "保护构造",
    "補足事項 / コメント": "押しボタンスイッチ/表示灯"
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_9",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_10",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_11",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_12",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_pushbutton_indicators_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "トグル/プッシュスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_2",
    "JA label": "接触仕様",
    "EN label": "Contact Form",
    "CN label": "接触规格",
    "補足事項 / コメント": "トグル/プッシュスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_3",
    "JA label": "定格(抵抗負荷)",
    "EN label": "Ratings",
    "CN label": "额定(电阻负载)",
    "補足事項 / コメント": "トグル/プッシュスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_4",
    "JA label": "スイッチ仕様",
    "EN label": "Switching Function",
    "CN label": "开关规格",
    "補足事項 / コメント": "トグル/プッシュスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_5",
    "JA label": "端子形状",
    "EN label": "Terminal",
    "CN label": "端子形状",
    "補足事項 / コメント": "トグル/プッシュスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_6",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_7",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_8",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_9",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_10",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_11",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_12",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_toggle_pushbutton_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_2",
    "JA label": "端子形状",
    "EN label": "Terminal",
    "CN label": "端子形状",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_3",
    "JA label": "端子ピッチ(mm)",
    "EN label": "Pitch(mm)",
    "CN label": "端子间距(mm)",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_4",
    "JA label": "サイズ幅 (mm)",
    "EN label": "Width size (mm)",
    "CN label": "宽度尺寸 (mm)",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_5",
    "JA label": "サイズ奥行 (mm)",
    "EN label": "Length size (mm)",
    "CN label": "长度尺寸 (mm)",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_6",
    "JA label": "サイズ高さ (mm)",
    "EN label": "Height size (mm)",
    "CN label": "高度尺寸 (mm)",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_7",
    "JA label": "極数",
    "EN label": "Poles",
    "CN label": "极数",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_8",
    "JA label": "種類 (操作)",
    "EN label": "Type",
    "CN label": "种类",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_9",
    "JA label": "ポジション",
    "EN label": "Positions",
    "CN label": "位置",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_10",
    "JA label": "アクチュエータ",
    "EN label": "Actuator",
    "CN label": "驱动器",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_11",
    "JA label": "出力コード",
    "EN label": "Output Code",
    "CN label": "输出导线",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_12",
    "JA label": "洗浄",
    "EN label": "Washable",
    "CN label": "清洗",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_13",
    "JA label": "梱包",
    "EN label": "Packaging",
    "CN label": "包装",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_14",
    "JA label": "シールテープ",
    "EN label": "Seal tape",
    "CN label": "密封构造",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_15",
    "JA label": "端子配置",
    "EN label": "Terminal arrangement",
    "CN label": "端子型",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_16",
    "JA label": "保護構造",
    "EN label": "Protection",
    "CN label": "保护构造",
    "補足事項 / コメント": "ディップスイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_dip_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_1",
    "JA label": "サイズ幅 (mm)",
    "EN label": "Width size (mm)",
    "CN label": "宽度尺寸 (mm)",
    "補足事項 / コメント": "車載用スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_2",
    "JA label": "サイズ奥行 (mm)",
    "EN label": "Length size (mm)",
    "CN label": "长度尺寸 (mm)",
    "補足事項 / コメント": "車載用スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_3",
    "JA label": "サイズ高さ (mm)",
    "EN label": "Height size (mm)",
    "CN label": "高度尺寸 (mm)",
    "補足事項 / コメント": "車載用スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_4",
    "JA label": "定格(抵抗負荷)",
    "EN label": "Ratings",
    "CN label": "额定(电阻负载)",
    "補足事項 / コメント": "車載用スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_5",
    "JA label": "接触仕様",
    "EN label": "Contact Form",
    "CN label": "接触规格",
    "補足事項 / コメント": "車載用スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_6",
    "JA label": "動作に必要な力(最大)(N)",
    "EN label": "Maximum Operating Force(N)",
    "CN label": "动作力(最大)(N)",
    "補足事項 / コメント": "車載用スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_7",
    "JA label": "電気的耐久性 (Min.)",
    "EN label": "Electrical Durability (Min.)",
    "CN label": "电气耐久性 (Min.)",
    "補足事項 / コメント": "車載用スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_8",
    "JA label": "アクチュエータ",
    "EN label": "Actuator",
    "CN label": "驱动器",
    "補足事項 / コメント": "車載用スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_9",
    "JA label": "端子形状",
    "EN label": "Terminal",
    "CN label": "端子构造",
    "補足事項 / コメント": "車載用スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_10",
    "JA label": "保護構造",
    "EN label": "Protective structure",
    "CN label": "保护构造",
    "補足事項 / コメント": "車載用スイッチ"
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_11",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_12",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "switch_automotive_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "コネクタ"
  },
  {
    "machine_name (Elasticsearch)": "connector_2",
    "JA label": "定格電流(A)",
    "EN label": "Rated Current(A)",
    "CN label": "额定电流(A)",
    "補足事項 / コメント": "コネクタ"
  },
  {
    "machine_name (Elasticsearch)": "connector_3",
    "JA label": "定格電圧(V)",
    "EN label": "Rated Voltage(V)",
    "CN label": "额定电压(V)",
    "補足事項 / コメント": "コネクタ"
  },
  {
    "machine_name (Elasticsearch)": "connector_4",
    "JA label": "コネクタ形状\n(プラグ/ソケット)",
    "EN label": "Plug/Socket",
    "CN label": "插头/插座",
    "補足事項 / コメント": "コネクタ"
  },
  {
    "machine_name (Elasticsearch)": "connector_5",
    "JA label": "端子構造",
    "EN label": "Terminal",
    "CN label": "端子构造",
    "補足事項 / コメント": "コネクタ"
  },
  {
    "machine_name (Elasticsearch)": "connector_6",
    "JA label": "極数",
    "EN label": "Number of Contacts",
    "CN label": "极数",
    "補足事項 / コメント": "コネクタ"
  },
  {
    "machine_name (Elasticsearch)": "connector_7",
    "JA label": "ピッチ(mm)",
    "EN label": "Pitch(mm)",
    "CN label": "间距(mm)",
    "補足事項 / コメント": "コネクタ"
  },
  {
    "machine_name (Elasticsearch)": "connector_8",
    "JA label": "ロック方式",
    "EN label": "Lock Type",
    "CN label": "锁定方式",
    "補足事項 / コメント": "コネクタ"
  },
  {
    "machine_name (Elasticsearch)": "connector_9",
    "JA label": "基板接続方向\n(接点方向)",
    "EN label": "Contact Side",
    "CN label": "触点种类",
    "補足事項 / コメント": "コネクタ"
  },
  {
    "machine_name (Elasticsearch)": "connector_10",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_11",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_12",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "connector_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_1",
    "JA label": "製品カテゴリ",
    "EN label": "Category",
    "CN label": "类别",
    "補足事項 / コメント": "流量センサ"
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_2",
    "JA label": "適応流体",
    "EN label": "Applicable Gas",
    "CN label": "适用流体",
    "補足事項 / コメント": "流量センサ"
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_3",
    "JA label": "流量/流速/差圧範囲",
    "EN label": "Flow Rate/Flow Velocity/Differential Pressure",
    "CN label": "流量/流速/差压范围",
    "補足事項 / コメント": "流量センサ"
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_4",
    "JA label": "電源電圧(DC)(V)",
    "EN label": "Power Supply(VDC)",
    "CN label": "电源电压(DC)(V)",
    "補足事項 / コメント": "流量センサ"
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_5",
    "JA label": "出力信号",
    "EN label": "Voltage Output Signal",
    "CN label": "输出信号",
    "補足事項 / コメント": "流量センサ"
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_6",
    "JA label": "継手形状",
    "EN label": "Connect",
    "CN label": "接头形状",
    "補足事項 / コメント": "流量センサ"
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_7",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_8",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_9",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_10",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_11",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_12",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_flow_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_1",
    "JA label": "接続方式",
    "EN label": "Sensing method",
    "CN label": "感应方式",
    "補足事項 / コメント": "フォト・マイクロセンサ（透過形）"
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_2",
    "JA label": "取り付け",
    "EN label": "Terminal Shape",
    "CN label": "端子形状",
    "補足事項 / コメント": "フォト・マイクロセンサ（透過形）"
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_3",
    "JA label": "出力形態",
    "EN label": "Output Configuration",
    "CN label": "输出形态",
    "補足事項 / コメント": "フォト・マイクロセンサ（透過形）"
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_4",
    "JA label": "溝幅/検出距離(mm)",
    "EN label": "Slot Width/Sensing Distance(mm)",
    "CN label": "槽宽/检测距离(mm)",
    "補足事項 / コメント": "フォト・マイクロセンサ（透過形）"
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_5",
    "JA label": "受光スリット幅(mm)",
    "EN label": "Aperture Width(mm)",
    "CN label": "狭缝宽(mm)",
    "補足事項 / コメント": "フォト・マイクロセンサ（透過形）"
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_6",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_7",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_8",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_9",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_10",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_11",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_12",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_transmissive_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_1",
    "JA label": "接続方式",
    "EN label": "Sensing method",
    "CN label": "感应方式",
    "補足事項 / コメント": "フォト・マイクロセンサ（反射形）"
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_2",
    "JA label": "取り付け",
    "EN label": "Terminal Shape",
    "CN label": "端子形状",
    "補足事項 / コメント": "フォト・マイクロセンサ（反射形）"
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_3",
    "JA label": "出力形態",
    "EN label": "Output Configuration",
    "CN label": "输出形态",
    "補足事項 / コメント": "フォト・マイクロセンサ（反射形）"
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_4",
    "JA label": "検出距離(mm)",
    "EN label": "Sensing Distance(mm)",
    "CN label": "检测距离(mm)",
    "補足事項 / コメント": "フォト・マイクロセンサ（反射形）"
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_5",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_6",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_7",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_8",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_9",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_10",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_11",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_12",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_13",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_14",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_15",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_16",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_17",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_18",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_19",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  },
  {
    "machine_name (Elasticsearch)": "sensor_photomicro_reflective_20",
    "JA label": "",
    "EN label": "",
    "CN label": "",
    "補足事項 / コメント": ""
  }
]
